import { render } from "./sql-chapter-3.vue?vue&type=template&id=09fd1e8a"
import script from "./sql-chapter-3.vue?vue&type=script&lang=js"
export * from "./sql-chapter-3.vue?vue&type=script&lang=js"

import "./sql-chapter-3.vue?vue&type=style&index=0&id=09fd1e8a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__